export const CONTENT_MAX_LENGTH = 1200;
